<template>
    <div class="alert-secondary mb-3">
        <b-row>
            <b-col>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-button @click="showFilters = !showFilters">
                            <b-icon-chevron-down v-if="showFilters"></b-icon-chevron-down>
                            <b-icon-chevron-right v-else></b-icon-chevron-right>
                            <span class="p-xl-2 pl-2 pr-1">Filters</span>
                        </b-button>
                    </b-input-group-prepend>

                    <b-form-input type="search" v-model="query" v-on:keyup.enter="search()"></b-form-input>

                    <b-input-group-append>
                        <b-button variant="primary" @click="search()">Search</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <b-row class="p-3" v-if="showFilters">
            <b-col>
                <b-form-checkbox size="sm" v-model="filters.isNewOrder">New</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.paid">Paid</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.unpaid">Unpaid</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.unprinted">Unprinted</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.queue">Queue</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noCustomerId">No Cust ID</b-form-checkbox>            
                <b-form-checkbox size="sm" v-model="filters.noPhone">No Phone</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.noLatinTaxId">No Latin Tax ID</b-form-checkbox>
            </b-col>

            <b-col>
                <b-form-checkbox size="sm" v-model="filters.shipped">Shipped</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.unshipped">Unshipped</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.hasRefund">Has Refund</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.domestic">Domestic</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.international">International</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.unmerged">Uncombined</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.other">Other Flag</b-form-checkbox>
                <b-form-checkbox size="sm" v-model="filters.zeroQtyItems">0 Qty</b-form-checkbox>
            </b-col>

            <b-col cols="4">
                <b-input-group>
                    <b-form-datepicker size="sm"
                                    placeholder="Ordered From"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.orderDate"
                    ></b-form-datepicker>

                    <b-form-datepicker size="sm"
                                    placeholder="Ordered To"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    v-model="filters.orderDateTo"
                    ></b-form-datepicker>
                </b-input-group>
                <b-input-group>
                    <b-form-select size="sm" v-model="filters.location" :options="locationOptions">
                        <template #first>
                            <b-form-select-option :value="null">Location</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select size="sm" v-model="filters.platform" :options="platformOptions">
                        <template #first>
                            <b-form-select-option :value="null">Platform</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>
                <b-input-group>
                    <b-form-select size="sm" v-model="filters.shippingMethod" :options="shippingOptions">
                        <template #first>
                            <b-form-select-option :value="null">Shipping Method</b-form-select-option>
                        </template>
                    </b-form-select>
           
                    <b-form-select size="sm" v-model="filters.customerCountry" value-field="code" text-field="name" :options="countries">
                        <template #first>
                            <b-form-select-option :value="null">Country</b-form-select-option>
                        </template>
                    </b-form-select>
             
                </b-input-group>

                <b-input-group>
                    <b-form-input size="sm" v-model="filters.customerCity" placeholder="City" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-input size="sm" v-model="filters.customerState" placeholder="State" v-on:keyup.enter="search()"></b-form-input>
                </b-input-group>

                <b-input-group>
                    <b-form-input size="sm" v-model="filters.customerId" placeholder="Customer ID" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-select size="sm" v-model="filters.itemQuantity">
                        <template #first>
                            <b-form-select-option :value="null">Item Quantity</b-form-select-option>
                        </template>
                        <b-form-select-option size="sm" value="singleItem">Single Item</b-form-select-option>
                        <b-form-select-option size="sm" value="multiItem">Multi Item</b-form-select-option>
                    </b-form-select>
                </b-input-group>
          
            </b-col>


            <b-col cols="4">
                <b-input-group>
                    <b-form-input class="shipInputs" size="sm" v-model="filters.platformId" placeholder="Site Order ID" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-input class="shipInputs" size="sm" v-model="filters.ebayUsername" placeholder="eBay Username" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-input class="shipInputs" size="sm" v-model="filters.discogsUsername" placeholder="Discogs Username" v-on:keyup.enter="search()"></b-form-input>
                </b-input-group>
                <b-input-group>
                    <b-form-input class="shipInputs" size="sm" v-model="filters.transactionId" placeholder="Transaction ID" v-on:keyup.enter="search()"></b-form-input>
                    <b-form-input class="shipInputs" size="sm" v-model="filters.trackingNumber" placeholder="Tracking Number" v-on:keyup.enter="search()"></b-form-input>
            </b-input-group>
                <b-input-group>
                        <b-form-datepicker size="sm"
                                        placeholder="Ship Date"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        v-model="filters.shipDate"
                        ></b-form-datepicker>
                        <b-form-datepicker size="sm"
                                        placeholder="Ship Date To"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        v-model="filters.shipDateTo"
                        ></b-form-datepicker>
                        <b-form-input size="sm" v-model="filters.shippedBy" placeholder="Shipped by" v-on:keyup.enter="search()"></b-form-input>
                </b-input-group>
            </b-col>

          
               
           
            
            <b-col>
                <b-button variant="outline-primary" @click="clear" size="sm">
                    <b-icon-x></b-icon-x>
                    <span class="p-xl-2 pl-2 pr-1">Clear</span>
                </b-button>
            </b-col>
        </b-row>

        <!--<b-input-group class="mb-3">-->
            <!--<template #prepend>-->
                <!--<b-dropdown ref="filterDropdown" text="Filters" variant="outline-primary">-->
                    <!--<b-dropdown-form style="width: 15rem;">-->
                        <!--<b-input-group size="sm">-->
                            <!--<b-row>-->
                                <!--<b-col>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.isNewOrder">New</b-form-checkbox>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.paid">Paid</b-form-checkbox>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.shipped">Shipped</b-form-checkbox>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.unshipped">Unshipped</b-form-checkbox>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.unprinted">Unprinted</b-form-checkbox>-->
                                    <!--<b-form-checkbox class="mb-2" v-model="filters.domestic">Domestic</b-form-checkbox>-->

                                    <!--<b-form-select size="sm" v-model="filters.location" :options="locationOptions" class="mb-2">-->
                                        <!--<template #first>-->
                                            <!--<b-form-select-option :value="null">Location</b-form-select-option>-->
                                        <!--</template>-->
                                    <!--</b-form-select>-->
                                    <!--<b-form-select size="sm" v-model="filters.platform" :options="platformOptions">-->
                                        <!--<template #first>-->
                                            <!--<b-form-select-option :value="null">Platform</b-form-select-option>-->
                                        <!--</template>-->
                                    <!--</b-form-select>-->
                                <!--</b-col>-->
                            <!--</b-row>-->

                        <!--</b-input-group>-->

                        <!--<b-dropdown-divider class="mb-3 mt-3"></b-dropdown-divider>-->

                        <!--<b-row>-->
                            <!--<b-col align="right">-->
                                <!--<b-button-group size="sm">-->
                                    <!--<b-button variant="outline-secondary" @click="clear">-->
                                        <!--<b-icon-x></b-icon-x>-->
                                        <!--<span class="p-xl-2 pl-2 pr-1">Clear</span>-->
                                    <!--</b-button>-->
                                    <!--<b-button variant="outline-primary" @click="search">-->
                                        <!--<b-icon-filter></b-icon-filter>-->
                                        <!--<span class="p-xl-2 pl-2 pr-1">Filter</span>-->
                                    <!--</b-button>-->
                                <!--</b-button-group>-->
                            <!--</b-col>-->
                        <!--</b-row>-->

                    <!--</b-dropdown-form>-->
                <!--</b-dropdown>-->
            <!--</template>-->
            <!--&lt;!&ndash;<b-form-tags class="py-1" style="max-width: 20%;">&ndash;&gt;-->
            <!--&lt;!&ndash;<b-form-tag&ndash;&gt;-->
                    <!--&lt;!&ndash;v-for="(value, filter, index) in activeFilters"&ndash;&gt;-->
                    <!--&lt;!&ndash;@remove="removeFilter(filter)"&ndash;&gt;-->
                    <!--&lt;!&ndash;:key="index"&ndash;&gt;-->
                    <!--&lt;!&ndash;class="px-2"&ndash;&gt;-->
                    <!--&lt;!&ndash;variant="primary"&ndash;&gt;-->
            <!--&lt;!&ndash;&gt;{{ filter }}<span v-if="typeof value === 'string'">: {{ value }}</span></b-form-tag>&ndash;&gt;-->
            <!--&lt;!&ndash;</b-form-tags>&ndash;&gt;-->

            <!--<b-form-input v-model="query" v-on:keyup.enter="search()"></b-form-input>-->

            <!--<b-input-group-append>-->
                <!--<b-button variant="primary" @click="search()">Search</b-button>-->
            <!--</b-input-group-append>-->
        <!--</b-input-group>-->
    </div>
</template>

<script>
    import platformOptions from "../../assets/platformOptions";
    import locationOptions from "../../assets/locationOptions";
    import ShippingOptionsMixin from "../../assets/shippingOptions";
    import countryList from "../../assets/countryList";

    export default {
        name: "OrderSearch",
        props: [ 'searchText', 'filters' ],
        mixins: [ platformOptions, locationOptions, ShippingOptionsMixin, countryList ],
        data() {
            return {
                showFilters: true,
                query: '',
                filterNames: {
                    isNewOrder: 'New',
                    unprinted: 'Unprinted',
                    paid: 'Paid',
                    unpaid: 'Unpaid',
                    queue: 'Queue',
                    unmerged: 'Uncombined',
                    noPhone: 'No Phone',
                    noLatinTaxId: 'No Latin Tax ID',
                    other: 'Other Flag',
                    shipped: 'Shipped',
                    unshipped: 'Unshipped',
                    hasRefund: 'Has Refund',
                    location: 'Location',
                    platform: 'Platform',
                    domestic: 'Domestic',
                    international: 'International',
                    platformId: 'Platform ID',
                    ebayUsername: 'eBay Username',
                    discogsUsername: 'Discogs Username',
                    trackingNumber: 'Tracking Number',
                    transactionId: 'Transaction ID',
                    shippingMethod: 'Shipping Method',
                    customerCountry: 'Country',
                    customerCity: 'City',
                    customerState: 'State',
                    itemQuantity: 'Items',
                    customerId: 'Customer ID',
                    noCustomerId: 'No Cust ID',
                    zeroQtyItems: '0 Qty',
                },
            }
        },
        created() {
            this.query = this.searchText;
        },
        methods: {
            removeFilter(filterText) {
                for (let key in this.filterNames) {
                    if (filterText === this.filterNames[key]) {
                        this.$emit('removeFilter', key);
                    }
                }
            },
            resetFilters() {
                this.$emit('clear');
            },
            search() {
                this.$emit('search', { query: this.query, filters: this.filters });
            },
            clear() {
                this.$emit('clear');
            },
        },
        computed: {
            activeFilters() {
                let active = {};

                for (let key in this.filters) {
                    if (this.filters[key]) {
                        active[this.filterNames[key]] = this.filters[key];
                    }
                }

                return active;
            }
        }
    }
</script>

<style scoped>
    .shipInputs {
        width: 33.33%;
    }
</style>